import CalorieTracker from './CalorieTracker';

function App() {
  return <CalorieTracker />;
}

export default App;
